import { render, staticRenderFns } from "./DoKoFullscreenBtn.vue?vue&type=template&id=1ffe2b6c&"
import script from "./DoKoFullscreenBtn.vue?vue&type=script&lang=ts&"
export * from "./DoKoFullscreenBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports